import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ModalComponent } from '../../../modals/modal/modal.component';

export interface CompetencyContentUpdate {
  index: number;
  gis: string[];
}

@Component({
  selector: 'app-edit-gi-content-modal',
  standalone: false,
  templateUrl: './edit-gi-content-modal.component.html',
  styleUrl: './edit-gi-content-modal.component.scss',
})
export class EditGiContentModalComponent implements OnInit, OnChanges {
  @ViewChild('modal')
  modal: ModalComponent;

  @Input() levelNames: string[];

  @Input() competencyTitle: string;

  @Input() competencyGis: string[];

  @Input() competencyIndex: number;

  @Output() readonly competencyGisUpdated =
    new EventEmitter<CompetencyContentUpdate>();

  gisForm: FormGroup;

  isUpdating = true;

  gisFormSubmitted = false;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.createFromControls();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['competencyGis'] &&
      changes['competencyGis'].currentValue !==
        changes['competencyGis'].previousValue &&
      changes['competencyGis'].firstChange === false
    ) {
      this.isUpdating = true;
      this.resetForm();
      this.createFromControls();
    }
  }

  get f() {
    return this.gisForm.controls;
  }

  createFromControls() {
    if (this.competencyGis) {
      this.gisForm = this.formBuilder.group({});

      for (let i = 1; i <= this.competencyGis.length; i += 1) {
        this.gisForm.addControl(
          `level${i}`,
          new FormControl(this.competencyGis[i - 1])
        );
      }
      this.isUpdating = false;
    }
  }

  removeAllFormGroupControls() {
    Object.keys(this.gisForm.controls).forEach((key) => {
      this.gisForm.removeControl(key);
    });
  }

  resetForm() {
    this.removeAllFormGroupControls();
    this.gisFormSubmitted = false;
    this.isUpdating = false;
  }

  closeModal() {
    this.resetForm();
    this.createFromControls();
    this.modal.close();
  }

  onSubmit() {
    this.gisFormSubmitted = true;
    if (this.gisForm.invalid) {
      return;
    }
    if (this.gisForm.pristine) {
      this.closeModal();
      return;
    }
    this.isUpdating = true;
    const updatedLevels: string[] = [];
    for (let i = 1; i <= this.competencyGis.length; i += 1) {
      updatedLevels.push(this.f[`level${i}`].value);
    }
    this.competencyGisUpdated.emit({
      index: this.competencyIndex,
      gis: updatedLevels,
    });
    setTimeout(() => {
      this.closeModal();
    }, 400);
  }
}
